exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#agendar{\r\n  padding-right: 0px !important;\r\n}\r\n.modal-dialog{\r\n  width: 100% !important;\r\n}\r\n.btn-success {\r\n  font-size: 14px !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/polizas/vam-titulares-polizas.styles.css
// module id = ../../../../../src/app/views/vam/polizas/vam-titulares-polizas.styles.css
// module chunks = 0